var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSoSafe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3763 13.6128C15.7693 14.584 14.4338 14.8875 13.4626 14.2805L6.05673 9.54562C4.59985 8.63507 3.75 7.11748 3.75 5.41779C3.75 3.71809 4.53915 2.2005 5.93533 1.22925C8.36346 -0.409748 11.52 -0.409748 13.9482 1.22925L15.7693 2.44331C16.7405 3.11105 16.9834 4.38583 16.3763 5.41779C15.7086 6.38904 14.4338 6.63185 13.4019 6.02482L11.5807 4.81075C10.6095 4.14301 9.27402 4.14301 8.30276 4.81075C8.05995 4.99286 7.99924 5.23567 7.99924 5.41779C7.99924 5.53919 8.05995 5.84271 8.30276 5.96412L15.7086 10.699C16.7405 11.306 16.9834 12.6415 16.3763 13.6128Z",
    fill: "#101010"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M7.57441 19.4404L4.66064 17.4978C3.68939 16.8301 3.44657 15.5553 4.05361 14.5234C4.72135 13.5521 5.99612 13.2486 7.02808 13.9163L9.94184 15.8589C10.9131 16.5266 11.1559 17.8014 10.5489 18.8333C9.88114 19.8046 8.54566 20.1081 7.57441 19.4404Z",
    fill: "#101010"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i",
    x: 3.75,
    y: 0,
    width: 14.1397,
    height: 15.776,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.18239,
    dy: 1.18239
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.985321
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0509804 0 0 0 0 0.152941 0 0 0 0 0.313726 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoSafe);
export default __webpack_public_path__ + "static/media/soSafe.be7df627334103a9614df9c4cd89e2f0.svg";
export { ForwardRef as ReactComponent };